<section class="bg-white">
	<div class="container">
		<div class="-mx-5 divider !border-b-0 sm:mx-0">
			<div class="grid gap-8 lg:mt-0 lg:grid-cols-1">
				<div class="flex flex-col">
					<div
						class="px-6 py-12 overflow-hidden border border-gray-200 bg-gray-50 sm:rounded-lg"
					>
						<div class="flex justify-center mb-6">
							<uc-euro-svg customStyles="mr-0.5"></uc-euro-svg>
							<uc-pound-svg customStyles="mr-0.5"></uc-pound-svg>
							<uc-dollar-svg customStyles="mr-0"></uc-dollar-svg>
						</div>
						<h2 class="m-auto text-xl font-bold leading-6 text-center">
							Fees and funding
						</h2>
						<p
							class="max-w-4xl px-6 m-auto mt-3 text-base text-center text-gray-500"
						>
							Unfortunately, we're unable to gather fee information for this
							course.
							<a
								class="font-bold text-gray-800 underline"
								[attr.href]="externalUrl()"
								rel="noopener"
								target="_blank"
								>Click here</a
							>
							to find out more about {{ courseName() }}'s funding options on
							the university's website.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
